module.exports = require("regenerator-runtime");



//////////////////
// WEBPACK FOOTER
// ./~/.6.23.0@babel-runtime/regenerator/index.js
// module id = 258
// module chunks = 0